@if (entity) {
  <div class="entity-detail-container">
    <div class="row">
      <!-- First Row -->
      <div class="col-md-4">
        <div class="form-group mb-4">
          <label class="form-label">Entity Name <span class="text-danger">*</span></label>
          <div class="form-control-display">{{ entity.name || '-' }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group mb-4">
          <label class="form-label">Group Account <span class="text-danger">*</span></label>
          <div class="form-control-display">{{ entity.groupAccount || '-' }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group mb-4">
          <label class="form-label">Governing Country <span class="text-danger">*</span></label>
          <div class="form-control-display">{{ entity.governingCountryName || '-' }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Second Row -->
      <div class="col-md-4">
        <div class="form-group mb-4">
          <label class="form-label">Domestic Jurisdiction <span class="text-danger">*</span></label>
          <div class="form-control-display">{{ entity.domesticJurisdictionName || '-' }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group mb-4">
          <label class="form-label">Date of Formation</label>
          <div class="form-control-display">{{ formatDate(entity.formationDate) }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group mb-4">
          <label class="form-label">Entity Type <span class="text-danger">*</span></label>
          <div class="form-control-display">{{ entity.entityTypeName || '-' }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Third Row -->
      <div class="col-md-4">
        <div class="form-group mb-4">
          <label class="form-label">Jurisdiction <span class="text-danger">*</span></label>
          <div class="form-control-display">{{ entity.jurisdictionName || '-' }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group mb-4">
          <label class="form-label">Date of Authorization</label>
          <div class="form-control-display">{{ formatDate(entity.authorizationDate) }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group mb-4">
          <label class="form-label">Jurisdiction ID Number</label>
          <div class="form-control-display">{{ entity.jurisdictionIdNumber || '-' }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Fourth Row -->
      <div class="col-md-6">
        <div class="form-group mb-4">
          <label class="form-label">Registered Agent <span class="text-danger">*</span></label>
          <div class="form-control-display">{{ entity.registeredAgentName || '-' }}</div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-4">
          <label class="form-label">Subject Entity ID</label>
          <div class="form-control-display readonly">{{ entity.subjectEntityId || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
}

@if (!entity) {
  <div class="text-center p-4">
    <p class="text-muted">No entity data available.</p>
  </div>
}